(function () {

    'use strict';

    angular.module('asys')
        .component('asysErgebnisZeileTarifdetails', {
            bindings: {
                tarifdetailsData: '@aeztData',
                tarifdetailsTextProp: '@?aeztTarifdetailsTextProp',
                tarifdetailsFilter: '@?aeztTarifdetailsFilter',
                tarifdetailsTemplateData: '<?aeztTarifdetailsTemplateData',
                avb: '@?aeztAvb',
                tarifarten: '<aeztTarifarten',
                baustein: '<aeztBaustein',
                bausteinKeys: '<aeztBausteinKeys',
                showTarifdetails: '<?aeztShowTarifdetails',
                onTarifdetailsFiltered: '&?aeztOnTarifdetailsFiltered',
                toggle: '&?aeztToggle',
                options: '<aeztOptions'
            },
            templateUrl: 'ergebnis/partials/ergebnisZeileTarifdetails.html',
            controller: ErgebnisZeileTarifdetailsController,
            controllerAs: 'ergZeileTarifdetailsVm'
        })
        .service('ErgebnisZeileTarifdetailsService', ErgebnisZeileTarifdetailsService);

    ErgebnisZeileTarifdetailsController.$inject = [
        '$scope',
        '$element',
        '$analytics',
        'lodash',
        'ErgebnisZeileTarifdetailsService',
        'MiscUtilsService'
    ];
    function ErgebnisZeileTarifdetailsController($scope, $element, $analytics, _, ErgebnisZeileTarifdetailsService, MiscUtilsService) {
        var vm = this,
            btnToggleText = {
                show: 'Tarifdetails einblenden',
                hide: 'Tarifdetails ausblenden'
            },
            tarifartMap = {
                p: 'plus',
                s: 'optimal',
                b: 'basis'
            },
            firstToggleBtn = $element.find('a');

        vm.isOpen = false;
        vm.tarifdetails = {};
        vm.tarifdetailsTarifarten = [];
        vm.toggleBtnText = vm.isOpen ? btnToggleText.hide : btnToggleText.show;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.onToggle = onToggle;
        vm.getLabel = getLabel;
        vm.getText = getText;
        vm.getId = getId;
        vm.isZeileSichtbar = isZeileSichtbar;
        vm.getMainCls = getMainCls;

        $scope.$watch(function () {
            return vm.showTarifdetails;
        }, function (value) {
            if (_.isBoolean(value) && vm.isOpen !== value) {
                _toggle(value);
            }
        });
        function _parseTarifarten() {
            var tarifartWert;

            vm.tarifdetailsTarifarten = [];

            _.forEach(_.compact(vm.tarifarten), function (tarifart) {
                tarifartWert = _.lowerCase(_.get(tarifart, 'wert'));

                tarifartWert = tarifartMap[tarifartWert] ? tarifartMap[tarifartWert] : tarifartWert;

                if (_.indexOf(vm.tarifdetailsTarifarten, tarifartWert) === -1) {
                    vm.tarifdetailsTarifarten.push(tarifartWert);
                }
            });

            vm.hasMehrereTarifarten = _.size(vm.tarifdetailsTarifarten) > 1;
        }
        function _toggle(open) {
            vm.isOpen = open;
            vm.toggleBtnText = vm.isOpen ? btnToggleText.hide : btnToggleText.show;

            $analytics.eventTrack('tarifdetails', {
                trackingProvider: 'wgv',
                target: vm.tarifdetailsData,
                value: open ? 'open' : 'close'
            });

            if (!firstToggleBtn[0]) {
                firstToggleBtn = $element.find('a');
            }

            if (firstToggleBtn[0] && _.isFunction(firstToggleBtn[0].focus)) {
                firstToggleBtn[0].focus();
            }
        }

        function activate() {
            vm.options = vm.options || {};
            vm.gridLayoutCss = vm.options.grid || {};
            vm.toggleBtnText = vm.isOpen ? btnToggleText.hide : btnToggleText.show;
            vm.textProp = vm.tarifdetailsTextProp || 'text';
            vm.bausteinKeys = vm.bausteinKeys ? _.flatten([vm.bausteinKeys]) : null;
            vm.tarifdetails = [];

            if (vm.baustein) {
                vm.tarifartAktiv = tarifartMap[_.toLower(_.get(vm.baustein, 'tarifartModellierung.wert'))];
            } else if (_.size(vm.tarifarten) === 1) {
                vm.tarifartAktiv = tarifartMap[_.toLower(vm.tarifarten[0].wert)];
            }

            if (vm.tarifdetailsData) {
                ErgebnisZeileTarifdetailsService.load(vm.tarifdetailsData).then(function (data) {
                    vm.tarifdetails = data || {};
                }).catch(function () {
                    vm.tarifdetails = [];
                }).finally(function () {
                    if (vm.bausteinKeys) {
                        _.each(_.keys(vm.tarifdetails), function (tarifdetailKey) {
                            vm.tarifdetails[tarifdetailKey] = _.filter(vm.tarifdetails[tarifdetailKey], function (tarifdetailZeile) {
                                return !_.has(tarifdetailZeile, 'bausteinKey') || _.some(tarifdetailZeile.bausteinKey, function (val) { return _.includes(vm.bausteinKeys, val); });
                            });
                        });
                    }

                    if (vm.tarifdetailsFilter || vm.avb) {
                        vm.filteredTarifdetails = {
                            permanent: _.filter(vm.tarifdetails.permanent, function (tarifdetail) {
                                return isZeileSichtbar(tarifdetail);
                            }),
                            optional: _.filter(vm.tarifdetails.optional, function (tarifdetail) {
                                return isZeileSichtbar(tarifdetail);
                            })
                        };
                    } else {
                        vm.filteredTarifdetails = vm.tarifdetails;
                    }

                    if (_.isFunction(vm.onTarifdetailsFiltered)) {
                        vm.onTarifdetailsFiltered({
                            tarifdetails: vm.filteredTarifdetails
                        });
                    }
                });
            }

            if (!vm.gridLayoutCss.columnLeft) {
                if (_.size(vm.tarifdetailsTarifarten) >= 2) {
                    vm.gridLayoutCss.columnLeft = 'small-12';
                } else {
                    vm.gridLayoutCss.columnLeft = 'small-12 medium-9';
                }
            }

            if (!vm.gridLayoutCss.columnRight) {
                if (_.size(vm.tarifdetailsTarifarten) >= 2) {
                    vm.gridLayoutCss.columnRight = 'small-12';
                } else {
                    vm.gridLayoutCss.columnRight = 'small-12 medium-3';
                }
            }

            if (!vm.gridLayoutCss.toggleBtn) {
                if (_.size(vm.tarifdetailsTarifarten) >= 2) {
                    vm.gridLayoutCss.toggleBtn = 'small-12 end text-center right';
                } else {
                    vm.gridLayoutCss.toggleBtn = 'small-12 medium-9 small-only-text-center end baustein-trenner';
                }
            }

            vm.gridLayoutCss.tarifartText = 'small-' + 12 / _.size(vm.tarifdetailsTarifarten);
        }

        function onInit() {
            vm.uuid = MiscUtilsService.guid();

            activate();
        }

        function onChanges(changes) {
            if (!_.isEqual(_.get(changes, 'tarifarten.currentValue'), _.get(changes, 'tarifarten.previousValue'))) {
                _parseTarifarten();
            }
            activate();
        }
        function onToggle() {
            _toggle(!vm.isOpen);

            if (_.isFunction(vm.toggle)) {
                vm.toggle({ open: vm.isOpen });
            }
        }
        function getText(tarifdetail, textProp) {
            return ErgebnisZeileTarifdetailsService.getText(tarifdetail, (textProp || vm.textProp), vm.tarifdetailsFilter, vm.tarifdetailsTemplateData, vm.avb);
        }

        function getLabel(tarifdetail) {
            return tarifdetail.label;
        }

        function getId() {
            return MiscUtilsService.guid();
        }
        function isZeileSichtbar(tarifdetail) {
            return (
                (
                    _.size(vm.tarifdetailsTarifarten) <= 1 &&
                    !_.isNil(getText(tarifdetail))
                ) || (
                    _.size(vm.tarifdetailsTarifarten) > 1 &&
                    _.some(vm.tarifdetailsTarifarten, function (tarifart) {
                        return !_.isNil(getText(tarifdetail, 'tarifarten.' + tarifart));
                    })
                )
            );
        }

        function getMainCls() {
            var cls = ['ergebnis-tarifdetails', 'ipjs-no-copy-check'];

            if (vm.hasMehrereTarifarten) {
                cls.push('mehrere-tarifarten');
                cls.push('tarifarten-' + _.size(vm.tarifdetailsTarifarten));
            }

            if (_.get(vm.gridLayoutCss, 'tarifdetailsMainCls')) {
                cls.push(vm.gridLayoutCss.tarifdetailsMainCls);
            }

            if (vm.tarifdetailsData) {
                cls.push(vm.tarifdetailsData);
            }

            return cls.join(' ');
        }
    }

    ErgebnisZeileTarifdetailsService.$inject =[
        '$http',
        '$q',
        'AppConfig',
        'lodash',
        'FormatUtilsService',
        'MiscUtilsService'
    ];

    function ErgebnisZeileTarifdetailsService($http, $q, AppConfig, _, FormatUtilsService, MiscUtilsService) {
        var that = this,
            serviceUrl = (AppConfig.APP.releaseDir ? AppConfig.APP.releaseDir + '/' : '') + 'data/ergebnisTarifdetails{0}.json';

        that.load = load;
        that.preload = preload;
        that.getText = getText;
        that.getFilterConditionKey = getFilterConditionKey;
        function load(tarifdetails) {
            if (!tarifdetails) {
                return $q.resolve({});
            }

            return $http.get(FormatUtilsService.replace(serviceUrl, _.upperFirst(tarifdetails)), {
                cache: true,
                httpErrorsIgnore: true
            }).then(function (response) {
                return response.data || {};
            }).catch(function () {
                return {};
            });
        }
        function preload(tarifdetails) {
            var preloadTarifdetails = [];

            if (_.isString(tarifdetails)) {
                preloadTarifdetails.push(tarifdetails);
            } else if (_.isArray(tarifdetails)) {
                preloadTarifdetails = tarifdetails;
            }

            _.forEach(preloadTarifdetails, function (val) {
                load(val);
            });
        }
        function getText(tarifdetail, textProp, filter, tarifdetailsTemplateData, avb) {
            var text,
                retValue,
                filterConditionKey,
                zeileFilter = _.get(tarifdetail, 'filter'),
                zeileFilterAvb = _.get(tarifdetail, 'avb');

            if (zeileFilterAvb) {
                if (!getFilterConditionKey(zeileFilterAvb, avb)) {
                    return;
                }
            }

            if (zeileFilter) {
                if (_.startsWith(zeileFilter, '<%=') && tarifdetailsTemplateData) {
                    zeileFilter = _.template(zeileFilter, { variable: 'data' })(tarifdetailsTemplateData);
                }

                if (!getFilterConditionKey(zeileFilter, filter)) {
                    return;
                }
            }

            text = _.get(tarifdetail, textProp, '');

            if (_.isObject(text)) {
                _.forEach(text, function (val, key) {
                    filterConditionKey = getFilterConditionKey(key, filter);
                    retValue = _.get(text, filterConditionKey);

                    if (retValue) {
                        return false;
                    }
                });
            } else {
                retValue = text;
            }

            if (retValue) {
                retValue = retValue.replace(/✓/g,'<i class="icon included" title="Versichert" aria-label="Versichert"></i><span class="sr-only">Versichert</span>').replace(/－/g,'<i class="icon not-included" title="Nicht versichert" aria-label="Nicht versichert">－</i><span class="sr-only">Nicht versichert</span>');
            }

            return retValue;
        }
        function getFilterConditionKey(filterCondition, filterVal) {
            filterCondition = filterCondition || '';

            if (MiscUtilsService.isEmpty(filterVal)) {
                return null;
            }

            if (MiscUtilsService.checkFilterCondition(filterCondition, filterVal)) {
                return filterCondition;
            }

            return null;
        }
    }

})();
